import { createMuiTheme } from "@material-ui/core/styles";
import {
  white,
  black,
  grey,
  error,
  greenDark,
  green,
  blue,
  bordo,
  bordoLight,
  greyMinor,
  greyTransparent,
  warning,
} from "./../constants/colors";

const theme = createMuiTheme({
  breakpoints: {
    values: { xs: 360, sm: 768, md: 1140, lg: 1400, xl: 1920 },
  },
  spacing: 10,
  palette: {
    primary: {
      main: bordo,
      light: bordoLight,
    },
    secondary: {
      main: white,
      error: error,
      success: green,
      telegram: blue,
    },
    text: {
      primary: black,
      secondary: greyMinor,
      light: greyTransparent,
    },
  },
  typography: {
    useNextVariants: true,
    // fontSize: 10,
    htmlFontSize: 10,
    h1: {
      fontFamily: "sbcBold",
      fontSize: "3.6rem",
      lineHeight: 1.3,
      fontWeight: "bold",
    },
    h2: {
      fontFamily: "sbcBold",
      fontSize: "2.5rem",
      lineHeight: 1.3,
      fontWeight: "bold",
    },
    h3: {
      fontFamily: "sbcBold",
      fontSize: "1.9rem",
      lineHeight: 1.5,
      fontWeight: "bold",
    },
    h4: {
      fontFamily: "sbcBold",
      fontSize: "1.8rem",
      lineHeight: 1.5,
      fontWeight: "bold",
    },
    h5: {
      fontFamily: "sbcRegular",
      fontSize: "10px",
      lineHeight: 1.5,
      fontWeight: "normal",
    },
    body1: {
      fontFamily: "sbcRegular",
      fontSize: "1.6rem",
      lineHeight: 1.5,
      fontWeight: "normal",
    },
    body2: {
      fontFamily: "sbcBold",
      fontSize: "1.6rem",
      lineHeight: 1.2,
      fontWeight: "bold",
    },
    subtitle1: {
      fontFamily: "sbcBold",
      fontSize: "1.4rem",
      lineHeight: 1.2,
      fontWeight: "bold",
      letterSpacing: "0.1em",
    },
    subtitle2: {
      fontFamily: "sbcRegular",
      fontSize: 12,
      lineHeight: 1.5,
      fontWeight: "bold",
    },
    caption: {
      fontFamily: "sbcRegular",
      fontSize: "12px",
      lineHeight: 1.5,
      fontWeight: "normal",
    },
    button: {
      fontFamily: "sbcRegular",
      fontSize: "2rem",
      lineHeight: 1.2,
      fontWeight: "normal",
      textTransform: "none",
      letterSpacing: "-0.03rem",
    },
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: "55px",
        fontSize: "12px",
        textTransform: "uppercase",
        fontFamily: "sbcBold",
      },
      contained: {
        padding: "9px 18px",
        transition: "all 0.3s ease",
        "&$disabled": {
          opacity: "0.3",
          boxShadow: "none",
          backgroundColor: grey,
          transition: "all 0.3s ease",
        },
      },
      outlined: {
        padding: "21px 45px",
        "&$disabled": {
          opacity: "0.5",
          boxShadow: "none",
          border: `2px solid ${grey}`,
          color: grey,
        },
      },
      containedPrimary: {
        padding: "9px 18px",
        color: white,
        backgroundColor: green,
        transition: "all 0.3s ease",
        "&.Mui-disabled": {
          "& p": {
            color: white,
          },
        },
        "& p": {
          fontSize: "12px",
          fontFamily: "sbcBold",
        },
        "&:hover": {
          backgroundColor: greenDark,
        },
      },
      outlinedPrimary: {
        padding: "23px 45px",
        borderWidth: "2px",
        transition: "all 0.3s ease",
        background: white,
        "& span": {
          transition: "all 0.3s ease",
        },
        "&:hover": {
          border: `2px solid ${error}`,
          backgroundColor: white,
          "& span": {
            color: error,
          },
        },
      },
    },
  },
});

export default theme;
